import { Directive, ElementRef, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isString } from 'util';
import { CurrencyNumberPipe } from '../pipes/currency-number.pipe';

@Directive({
    selector: '[appCurrencyNumber]'
})
export class CurrencyNumberDirective implements OnInit {
    private el: HTMLInputElement;
    @Input() allowNegative = false;
    @Output() change: EventEmitter<object> = new EventEmitter<object>();
    @Input() fractionSize = 2;
    private isInvalidNumber = false;
    constructor(private elementRef: ElementRef,
        private currencyPipe: CurrencyNumberPipe) {
        this.el = this.elementRef.nativeElement;
    }

    ngOnInit() {
        this.el.value = this.currencyPipe.transform(this.el.value);
    }

    cutString(value: string) {
        let i = 0;
        let newStr = value;
        const lens = newStr.length;
        let countDot = 0;
        while (i < lens) {
            if (newStr[i] === '.') {
                countDot++;
            }
            if (this.allowNegative) {
                if (newStr[i] === '-' && i > 0) {
                    this.isInvalidNumber = true;
                    newStr = this.changeMinus(newStr, i, newStr[i]);
                } else {
                    if ((isNaN(parseInt(newStr[i], 0)) && newStr[i] !== '.' && newStr[i] !== '-') || (countDot > 1)) {
                        newStr = newStr.substr(0, i) + newStr.substr(i + 1);
                    }
                }
            } else {
                if ((isNaN(parseInt(newStr[i], 0)) && newStr[i] !== '.') || (countDot > 1)) {
                    newStr = newStr.substr(0, i) + newStr.substr(i + 1);
                }
            }
            i++;
        }
        return newStr;
    }

    changeMinus(str: string, index: number, char: string) {
        if (char === '-') {
            if (char === str[0]) {
                const temp = str.split('-');
                let newStr = '';
                if (temp) {
                    let i = 0;
                    while (i < temp.length) {
                        newStr += temp[i];
                        i++;
                    }
                }
                return newStr;
            } else {
                return char + str.substr(0, index) + str.substr(index + 1);
            }
        }
        return str;

    }

    check(event: string): string {
        if (typeof event == 'number') {
            return this.currencyPipe.transform(event)
        }
        const newStr = this.cutString(event);
        const newArr = newStr ? newStr.split('.')[1] : null;
        let val = '';
        if (newArr) {
            if (newArr.length > 2) {
                val = this.currencyPipe.transform(newStr);
            } else {
                val = newStr;
            }
        } else {
            val = newStr;
        }
        return val;
    }

    inputOnChange(event: string) {
        if (event) {
            this.el.value = this.check(event);
        }
        if (this.isInvalidNumber) {
            this.isInvalidNumber = false;

            this.change.emit({ IsInvalidNumber: true, Value: this.el.value, Id: this.el.id });
        } else {
            return this.el.value;
        }

    }

    @HostListener('blur', ['$event.target.value'])
    onBlur(value) {
        const newValue = parseFloat(value);
        this.el.value = this.currencyPipe.transform(newValue, this.fractionSize);
    }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        this.inputOnChange(event);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/directives/currency-number.directive.ts